const validate = require('@weo-edu/validate')
const Schema = require('@weo-edu/schema')

const getAccessToken = Schema()
const logout = Schema()

exports.getAccessToken = validate(getAccessToken)
exports.logout = validate(logout)
